import React, { useState } from 'react';

interface DebugPanelProps {
  debugLogs: string[];
  clearDebugLogs: () => void;
  piSDKLoaded: boolean;
}

const DebugPanel: React.FC<DebugPanelProps> = ({
  debugLogs,
  clearDebugLogs,
  piSDKLoaded,
}) => {
  const [showDebugPanel, setShowDebugPanel] = useState(false);

  if (!showDebugPanel) {
    return (
      <button
        onClick={() => {
          console.log('Debug button clicked!');
          setShowDebugPanel(true);
        }}
        style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          width: '80px',
          height: '40px',
          fontSize: '12px',
          cursor: 'pointer',
          zIndex: 1000,
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
        }}
      >
        DEBUG
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        width: '300px',
        maxHeight: '400px',
        background: 'rgba(0,0,0,0.9)',
        color: 'white',
        borderRadius: '8px',
        padding: '10px',
        fontSize: '12px',
        zIndex: 1000,
        boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <strong>🔧 Debug Panel</strong>
        <button
          onClick={() => setShowDebugPanel(false)}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          ×
        </button>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Pi SDK Status:</strong>{' '}
        {piSDKLoaded ? '✅ Loaded' : '⏳ Loading...'}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Hostname:</strong> {window.location.hostname}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Pi Object:</strong>{' '}
        {window.Pi ? '✅ Available' : '❌ Not Found'}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Recent Logs:</strong>
      </div>

      <div
        style={{
          maxHeight: '200px',
          overflowY: 'auto',
          background: 'rgba(255,255,255,0.1)',
          padding: '5px',
          borderRadius: '4px',
          fontSize: '10px',
        }}
      >
        {debugLogs.length === 0 ? (
          <div>No logs yet...</div>
        ) : (
          debugLogs.map((log, index) => (
            <div
              key={index}
              style={{ marginBottom: '2px', wordBreak: 'break-word' }}
            >
              {log}
            </div>
          ))
        )}
      </div>

      <button
        onClick={clearDebugLogs}
        style={{
          marginTop: '10px',
          background: '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          padding: '5px 10px',
          fontSize: '10px',
          cursor: 'pointer',
        }}
      >
        Clear Logs
      </button>
    </div>
  );
};

export default DebugPanel;
